import { makeStyles } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PlateSamplingHeader from '../../QualityCheck/Creation/PlateSamplingHeader';
import PlateSamplingLeftBar from '../../QualityCheck/Creation/PlateSamplingLeftBar';
import QualityCheckForm from '../../QualityCheck/Creation/QualityCheckForm';
import SamplingResultsOKContent from '../../QualityCheck/Result/SamplingResultsOKContent';
import SamplingResultsNotOKContent from '../../QualityCheck/Result/SamplingResultsNotOKContent';
import { useHistory } from 'react-router-dom';
import { dataService } from '../../../Services/data.service'
import { toast } from 'react-toastify';
import AlertDialog from '../../Shared/Dialogs/AlertDialog';
import { connect } from 'react-redux';
import { qualitySampleResults } from '../../../Config/constants';

export const PlateSamplingPage = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    let history = useHistory();
    const [productionOrder, setProductionOrder] = useState(null);
    const [resultShown, setResultShown] = useState(false);
    const [qualityChecksNotOk, setQualityChecksNotOk] = useState([]);
    const [qualityChecks, setQualityChecks] = useState(null);
    const [wrongBarcodeDialogOpen, setWrongBarcodeDialogOpen] = useState(false);
    const [dialogTitle, setDialogTitle] = useState(null);
    const [dialogContext, setDialogContext] = useState(null);

    useEffect(() => {
        dataService.getOrderDetailsByOrderId(parseInt(props.match.params.id)).then(order => {
            setProductionOrder(order);
            dataService.getQualitySamplesByBarcode(props.match.params.barcode, props.match.params.id, order.bomOut[0].productId).then((qualitySamples) => {
                if (!qualitySamples) {
                    setDialogTitle(t("Wrong barcode!"));
                    setDialogContext(t("Given barcode ") + props.match.params.barcode + t(" is not assigned to production order ") + order.reference);
                    setWrongBarcodeDialogOpen(true);
                    return;
                }

                setQualityChecks(qualitySamples)
                if (parseInt(props.match.params.samplesTaken) === 1) {
                    setResultShown(true);
                    var sequence = qualitySamples.qualitySamples.length - 2;
                    var i;
                    var qualitySamplesNotOK = [];
                    for (i = 0; i < qualitySamples.qualitySamples[sequence].samples.length; i++) {
                        if (qualitySamples.qualitySamples[sequence].samples[i].result === qualitySampleResults.ERROR || qualitySamples.qualitySamples[sequence].samples[i].result === qualitySampleResults.WARNING) {
                            qualitySamplesNotOK.push(qualitySamples.qualitySamples[sequence].samples[i]);
                        }
                    }
                    setQualityChecksNotOk(qualitySamplesNotOK);
                }

            }).catch((error) => { toast.error(error, { position: "top-center" }) });

        }).catch((error) => { toast.error(error, { position: "top-center" }) });
        // eslint-disable-next-line
    }, [props.match.params])


    const finishTest = () => {
        history.push('/qualitychecks/' + props.match.params.progress + "/" + props.match.params.id + '/' + props.match.params.orderLineId);
    }

    const wrongBarcodeAction = () => {
        if (props.match.params.origin === 'detail') {
            history.push('/order/' + props.match.params.id + '/' + props.match.params.orderLineId);
        }
        else {
            history.push('/qualitychecks/' + props.match.params.progress + "/" + props.match.params.id + '/' + props.match.params.orderLineId);
        }
    }

    return (
        // <div className={classes.background}>
        <React.Fragment>
            {(productionOrder && qualityChecks) ? <React.Fragment><PlateSamplingHeader productionOrder={productionOrder} {...props}></PlateSamplingHeader>
                <div className={classes.body}>
                    <PlateSamplingLeftBar productionOrder={productionOrder} barcode={props.match.params.barcode} {...props}></PlateSamplingLeftBar>
                    {(resultShown)
                        ? qualityChecksNotOk.length === 0
                            ? <SamplingResultsOKContent finishTest={finishTest}></SamplingResultsOKContent>
                            : <SamplingResultsNotOKContent finishTest={finishTest} qualityChecksNotOK={qualityChecksNotOk} productionOrder={productionOrder} {...props}></SamplingResultsNotOKContent>
                        : <QualityCheckForm setQualityChecks={setQualityChecks} productionOrder={productionOrder} qualityChecks={qualityChecks} {...props} progress={props.match.params.progress} palletNumber={props.match.params.barcode} machineId={props.match.params.machineId}></QualityCheckForm>
                    }
                </div></React.Fragment> : <React.Fragment></React.Fragment>}
            {wrongBarcodeDialogOpen && <AlertDialog dialogOpen={wrongBarcodeDialogOpen} dialogTitle={dialogTitle} dialogContext={dialogContext} closeDialog={() => setWrongBarcodeDialogOpen(false)} action={() => wrongBarcodeAction()}></AlertDialog>}
        </React.Fragment>
        // </div>
    )
}

const useStyles = makeStyles({
    background: {
        paddingLeft: "30px"
    },
    body: {
        paddingLeft: "20px"

    }
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation
    }
}

export default connect(mapStateToProps)(PlateSamplingPage)